import { NgClass, NgFor, NgIf, NgOptimizedImage, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, HostListener, Input, OnInit, afterNextRender, afterRender, inject, input } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { DashboardFeeds } from '@apply4u/models';
import { Shared } from '@apply4u/models/shared';
import { ContextService } from '@apply4u/services/context-service';
import { DashboardService } from '@apply4u/services/dashboard.service';
import { LocalstorageService } from '@apply4u/services/localstorage.service';
import { ConfirmationService } from '@apply4u/shared/components/confirmation-modal/confirmation.service';
import { LoginTypeKeys } from '@apply4u/shared/constant/Local-storage-keys/login-type-keys';
import { HeaderContent } from '@apply4u/shared/constant/configure-content/header-content';
import { ConfirmationMessages } from '@apply4u/shared/constant/messages/confirmation-messages';
import { AccountSetting_RouteUrl, BrowseCVs_By_Industry_RouteUrl, BrowseCVs_By_Location_RouteUrl, Navigation } from '@apply4u/shared/constant/navigation/navigation';
import { IsUrlHostNameExists, RemoveElementById } from '@apply4u/shared/helpers/common/common-helpers';
import { IsAny, IsFalse, IsNotNull, IsNotNullOrEmpty, IsNotZero, IsNotZeroNumber } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { filter } from 'rxjs/internal/operators/filter';
import { DropdownItemsComponent } from './dropdown-items/dropdown-items.component';
import { LocalDateTimePipe } from '@apply4u/shared/pipes/local-date-time.pipe';
import { TimeagoPipe } from '@apply4u/shared/pipes/timeago.pipe';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserConnectionService } from '@apply4u/services/userConnection.service';
import { UserConnection } from '@apply4u/models/userConnection';

@Component({
  selector: 'smart-header',
  templateUrl: './smart-header.component.html',
  styleUrls: ['./smart-header.component.css'],
  standalone: true,
  imports: [NgIf, RouterLink, RouterLinkActive,
    RouterLinkActive, NgFor, DropdownItemsComponent, NgOptimizedImage,
    SlicePipe, NgClass, LocalDateTimePipe, TimeagoPipe]
})
export class SmartHeaderComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  Navigations = Navigation;
  ProfileImageUrl: string = "assets/images/profileicon.webp";
  MyProfileRedirectedUrl: string;
  loggedInUserId: number;
  CVsByLocation = BrowseCVs_By_Location_RouteUrl;
  CVsByIndustry = BrowseCVs_By_Industry_RouteUrl;
  TotalNotification: number = 0;
  TotalMessageNotifications: number = 0;
  UserConnections: UserConnection[] = [];
  NoConnection: boolean = false;

  Notificatiosns: DashboardFeeds[] = [];
  ShowHideNotification: boolean = false;
  NotificationPageSize: number = 10;
  TotalFeedCounts: number = 0;
  MyProfile: string;
  ShowBanner: boolean = true;
  NavbarCollapse: boolean = true;
  MyProfileState: boolean = false;

  @Input({ required: true })
  ContextService: ContextService;
  constructor(private localStorageService: LocalstorageService,
    private userConnectionService: UserConnectionService,
    private dashboardService: DashboardService,
    private router: Router,
    private elementRef: ElementRef,
    private confirmService: ConfirmationService) {
    afterNextRender(() => {
      this.SetUserProfileImage();
      // this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      //   .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: NavigationEnd) => {
      //     this.SetUserProfileImage();
      //   });

      if (this.ContextService.IsUserLoggedIn) {
         this.GetNotificationCount();
        this.GetTotalFeedCount();
      }
      this.LoadTrustPilot();
    }
    );
  }

  ngOnInit() {
    if(this.ContextService.IsBrowser){
      this.GetUserConnectedAsync();
    }
  }

  MyProfileToggle(event: MouseEvent) {
    this.MyProfileState = !this.MyProfileState
    event.stopPropagation();
  }

  UpdateImageAfterUpload() {
    this.SetUserProfileImage();
    window.location.reload();
  }

  ToggleNavbarCollapse() {
    var element = document.getElementById('navbartoggle');
    if (IsNotNull(element)) {
      element.click();
    }
    this.NavbarCollapse = !this.NavbarCollapse;
  }

  LoadTrustPilot(): void {
    if (this.ContextService.IsBrowser) {
      RemoveElementById("TrustPilotScript");
      var aScript = document.createElement('script');
      aScript.type = 'text/javascript';
      aScript.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
      aScript.async = true;
      aScript.defer = true
      aScript.id = "TrustPilotScript";
      document.head.appendChild(aScript);
      aScript.onload = function () {
        var trustbox = document.getElementById('trustbox-rating-mini');
        window.Trustpilot.loadFromElement(trustbox);
      };
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.ShowHideNotification) {
      if (!this.elementRef.nativeElement.contains(event.target)) {
        this.ShowHideNotification = false;
      }
    }
  }

  SetUserProfileImage() {
    let profileImage = this.localStorageService.GetItem(LoginTypeKeys.ProfileImagePath);

    this.MyProfile = this.localStorageService.GetItem(LoginTypeKeys.UserFirstName);

    if (IsNotNullOrEmpty(profileImage)) {
      if (IsUrlHostNameExists(profileImage) == false) {
        this.ProfileImageUrl = (Shared.baseUrl + profileImage);
        this.ProfileImageUrl = encodeURI(this.ProfileImageUrl);
      } else {
        this.ProfileImageUrl = profileImage;
      }
    } else {
      this.ProfileImageUrl = this.ContextService.IsJobSeeker ? "assets/images/profileicon.webp" : "assets/images/profileiconRecruiter.webp";
    }

    let redirectedUrl = this.localStorageService.GetItem(LoginTypeKeys.LoggedInUserMyProfileRedirectedURL);

    if (IsNotNullOrEmpty(redirectedUrl)) {

      this.MyProfileRedirectedUrl = "/users/" + redirectedUrl;
    }
  }

  OnDashBoardStateChangeHanlder(): void {
    if (this.ContextService.IsBrowser) {
      if (this.ContextService.IsUserLoggedIn) {
        if (this.ContextService.IsJobSeeker ? this.ContextService.IsRecruiterTypeActivated : this.ContextService.IsJobSeekerTypeActivated) {
          this.ContextService.SetIsJobSeeker(this.ContextService.IsJobSeeker ? false : true);
          this.ToggleRedirection();
        } else {
          this.confirmService.SetMessage(this.ContextService.IsJobSeeker ? ConfirmationMessages.ConfirmationOnToggleSwitchToRecruit : ConfirmationMessages.ConfirmationOnToggleSwitchToJobSeeker).OpenConfirmationDialogue(IsOk => {
            if (IsOk) {
              this.router.navigateByUrl(AccountSetting_RouteUrl);
            }
          });
        }
      } else {
        this.ContextService.SetIsJobSeeker(this.ContextService.IsJobSeeker ? false : true);
        this.ToggleRedirection();
      }
    }
  }

  ToggleRedirection(): void {
    // if (this.searchService.IsSearchPage || this.searchService.IsAdvanceSearchPage) {
    //   this.searchService.SearchRedirection();
    // } else if (this.router.url == '/') {
    //   this.router.navigateByUrl('/recruiter');
    // } else if (this.router.url == '/recruiter') {
    //   this.router.navigateByUrl('/');
    // }
  }

  OnLogout(): void {
    this.ContextService.SignOutRedirect();
  }

  GetNotificationCount(): void {
    this.dashboardService.GetNotificationCount(this.ContextService.LoggedInUserId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (IsNotZero(result)) {
        this.TotalNotification = result;
      }
    });

    this.GetMessageNotificationCount();

    // if (IsNotNull(this.messageBroadcastService.HubConnection)) {
    //   this.messageBroadcastService.HubConnection.on(`OnMessageNotifications${this.ContextService.LoggedInUserId}`, () => {
    //     this.GetMessageNotificationCount();
    //   });
    // }
  }

  GetMessageNotificationCount(): void {
    this.dashboardService.GetMessageNotificationCount(this.ContextService.LoggedInUserId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
     if(this.UserConnections[0].CanUserSendMessage == true && this.UserConnections[0].StatusId == 1)
     {
      this.TotalMessageNotifications = result;
     }
    });
  }

  ToggleNotification(): void {
    this.ShowHideNotification = !this.ShowHideNotification;
    if (this.ShowHideNotification) {

      this.dashboardService.GetNotifications(this.ContextService.LoggedInUserId, 1, this.NotificationPageSize).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
        if (IsAny(result)) {
          this.Notificatiosns = [];
          this.Notificatiosns = result;
        } else {
          this.Notificatiosns = [];
        }
      });
    }
  }

  GetTotalFeedCount(): void {
    this.dashboardService.GetTotalFeedCounts(this.ContextService.LoggedInUserId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      this.TotalFeedCounts = result;
    });
  }

  LoadMoreFeedData(): void {
    if (this.ShowHideNotification) {
      this.Notificatiosns = [];
      this.NotificationPageSize += 10;

      this.dashboardService.GetNotifications(this.ContextService.LoggedInUserId, 1, this.NotificationPageSize).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
        if (IsAny(result)) {
          this.Notificatiosns = result;
        }
      });
    }
  }

  MarkedAsViewdHandler(notify: DashboardFeeds): void {
    if (IsNotNull(notify) && IsFalse(notify.IsViewed)) {
      this.dashboardService.MarkViewedNotification(notify.Id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(reuslt => {
        notify.IsViewed = true;

        if (IsNotZeroNumber(this.TotalNotification) && this.TotalNotification > 1) {
          this.TotalNotification = this.TotalNotification - 1;
        }
        else {
          this.TotalNotification = 0;
        }
      });
    }
  }

  OnDeleteFeedhandler(notify: DashboardFeeds): void {
    if (IsNotNull(notify) && IsNotZeroNumber(notify.Id) && notify.Id > 0) {
      this.dashboardService.DeleteFeed(notify.Id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
        this.Notificatiosns = this.Notificatiosns.filter(n => n.Id != notify.Id);

        if (notify.IsViewed != null && !notify.IsViewed) {
          if (IsNotZeroNumber(this.TotalNotification) && this.TotalNotification > 1) {
            this.TotalNotification = this.TotalNotification - 1;
          }
          else {
            this.TotalNotification = 0;
          }
        }
      });
    }
  }

  OnDownloadApp() {
    if (this.ContextService.LoggedInUserId) {
      this.localStorageService.SetItem(`appDownloaded_${this.ContextService.LoggedInUserId}`, 'true');

    }
  }

  get ShowDownloadBanner(): boolean {
    if (this.ContextService.LoggedInUserId) {
      return !this.localStorageService.GetItem(`appDownloaded_${this.ContextService.LoggedInUserId}`);
    }
    return true;
  }

  get IsSmartJobCardRoute(): boolean {
    const pattern = /(^\/jobs$|^\/jobs\/|\/jobs$)/;
    return pattern.test(this.router.url);
  }

  HideBanner() {
    this.ShowBanner = false;
  }

  SignInHandler(): void {
    this.ContextService.SignInRedirect(true, this.Navigations.DashBoard);
  }

  GetUserConnectedAsync() {
    let loggedinUserId = this.ContextService.LoggedInUserId;

    if (IsNotZero(loggedinUserId)) {
      this.userConnectionService.GetUserChatConnectionAsync(loggedinUserId).subscribe({
        next: connectionRequests => {
          if (IsAny(connectionRequests)) {
            this.UserConnections = connectionRequests.filter(connect => connect.StatusId == 1 || connect.StatusId == 3 || connect.StatusId == 4);
          } else {
            this.NoConnection == true;
          }
        }
      })
    }
  }

}
